module.exports = __webpack_public_path__ + "img/info.e24deec6.svg";